<benefits-dialog [open]="true" [heading]="'ASSET_CHARGES.WAIVE_TITLE' | translate" [eyebrow]="'ASSET_CHARGES.TITLE' | translate" (closed)="closed.emit()">
  <div class="waive-charge-dialog">
    <p>{{ 'ASSET_CHARGES.WAIVE_HINT' | translate }}</p>
    <label class="field" for="waive-charge-reason">
      <span class="field__label">{{ 'ASSET_CHARGES.WAIVE_REASON' | translate }}</span>
      <textarea id="waive-charge-reason" class="field__input" rows="3" [value]="reason()" (input)="reason.set($any($event.target).value)"></textarea>
    </label>
    @if (error(); as err) {
      <p class="wn-banner wn-banner--error" role="alert">{{ err }}</p>
    }
  </div>

  <ng-container benefitsDialogFooter>
    <button type="button" pButton [outlined]="true" [label]="'COMMON.CANCEL' | translate" (click)="closed.emit()"></button>
    <button type="button" pButton class="waive-charge-dialog__confirm" icon="pi pi-check" [label]="'ASSET_CHARGES.WAIVE' | translate" [disabled]="!valid() || saving()" (click)="confirm()"></button>
  </ng-container>
</benefits-dialog>
